import { createAppSlice } from "../../../shared/lib/store/createAppSlice.js";
import { name } from "../config/name.js";
const carInitialState = {
  model: null,
  price: null
};
const creditParametersInitialState = {
  type: null,
  downPayment: null,
  downPaymentAmount: null,
  residualPayment: null,
  residualPaymentAmount: null,
  numberOfPeriods: null
};
const financialProgramInitialState = {
  program: null
};
const initialState = {
  ...carInitialState,
  ...creditParametersInitialState,
  ...financialProgramInitialState
};
const slice = createAppSlice({
  name,
  initialState,
  reducers: {
    setCar(state, action) {
      Object.entries({
        ...action.payload,
        ...creditParametersInitialState,
        ...financialProgramInitialState
      }).forEach(([key, value]) => {
        Object.assign(state, { [key]: value });
      });
    },
    setCreditParameters(state, action) {
      Object.entries({ ...action.payload }).forEach(([key, value]) => {
        Object.assign(state, { [key]: value });
      });
    },
    setFinancialProgram(state, action) {
      Object.entries({ ...action.payload }).forEach(([key, value]) => {
        Object.assign(state, { [key]: value });
      });
    }
  }
});
const actions = {
  ...slice.actions
};
export {
  actions,
  carInitialState,
  creditParametersInitialState,
  financialProgramInitialState,
  initialState,
  slice
};
